import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import { getRelativeBasePath } from '../../../global/environments/path.js'
import { isInvestor } from '../../../global/authentication/authentication-manager.js'
import { Loader } from '../loader/loader.jsx'
import {
  DEFAULT_CLASSES,
  DEFAULT_PRODUCT,
  getInitDocData,
  getFundData,
  transfromRowForTable,
  productTypes,
  filterFundByClass,
} from './Helpers/Helper.js'
import { FundLiteratureFilter } from './FundLiteratureFilter.jsx'
import { FundLiteratureTable } from './FundLiteratureTable.jsx'

export const FundLiterature = () => {
  const IS_INVESTOR = isInvestor()
  const [documentInfo, setDocumentInfo] = useState({
    literatureDoctypes: {},
    prospectusDetail: {},
    mailOrderDetail: {},
    summaryProspectData: {},
  })
  const [activeProduct, setActiveProduct] = useState(DEFAULT_PRODUCT)
  const [fundsData, setFundsData] = useState({})
  const [inputValue, setInputValue] = useState('')
  const [selectedFilter, setSelectedFilter] = useState([])
  const [activeClass, setActiveClass] = useState(DEFAULT_CLASSES[activeProduct])
  const showClassOption = [
    'mutual-funds',
    'variable-products',
    'interval-funds',
  ].includes(activeProduct)

  const fetchClassData = async (docInfo = documentInfo) => {
    if (Object?.keys(docInfo?.prospectusDetail)?.length === 0) {
      return
    }
    setFundsData()
    setSelectedFilter([])
    setInputValue('')

    const data = await getFundData(docInfo, activeProduct)
    setActiveClass(DEFAULT_CLASSES[activeProduct] || data?.classOptions[0]?.key)
    setFundsData(data)
  }

  useEffect(() => {
    const init = async () => {
      const docInfo = await getInitDocData()
      setDocumentInfo(docInfo)
    }
    init()
  }, [])

  useEffect(() => {
    const hash = globalThis.location.hash.startsWith('#')
      ? globalThis.location.hash.substring(1)
      : ''

    const productType =
      hash === 'sma-completion-portfolios' ? 'managed-accounts' : hash

    if (productTypes[productType]) {
      setActiveProduct(productType)
    }
  }, [])

  useEffect(() => {
    fetchClassData()
  }, [documentInfo, activeProduct])

  const filterDataByClass = filterFundByClass(fundsData?.funds, activeClass)
  const filtersFunds = transfromRowForTable(
    filterDataByClass,
    selectedFilter,
    inputValue,
    'funds'
  )

  const handleTabClick = (product) => {
    globalThis.location.hash = `#${product}`
    setActiveProduct(product)
  }

  return (
    <div className="investment-products">
      {/* tabs */}
      <div className="u-paddingTop3gu u-borderColorNeutralLight u-borderTop0 u-borderBottom u-borderLeft0 u-borderRight0 u-bgColorWhite">
        <div className="u-sizeConstrained u-flex">
          <ul className="List List--inline List--selectable u-flexJustifyStart">
            {Object.entries(productTypes).map((item) => (
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions -- CTINEXT-4720
              <li
                key={item[0]}
                className={
                  'u-textSizeMsrp1 u-paddingHoriz4gu u-sm-paddingHoriz1gu u-textBold List-item u-sm-textSizeMsr u-sm-flex u-textCenter u-flexAlignItemsCenter u-sm-flexGrow1 u-lg-flexAlignItemsTop' +
                  (item[0] === activeProduct ? ' is-selected' : '') +
                  (item[1].isEnabled ? '' : ' u-hidden u-sm-hidden')
                }
                onClick={() => handleTabClick(item[0])}
                data-qa-automation={`${item[1].label} Product Tab`}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleTabClick(item[0])
                  }
                }}
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex={0}
              >
                {item[1].label}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="u-sizeConstrained u-paddingBottom15gu">
        {/* FILTER / SEARCH */}
        <FundLiteratureFilter
          {...{
            showClassOption,
            inputValue,
            setInputValue,
            activeClass,
            setActiveClass,
            classOptions: fundsData?.classOptions,
            filters: fundsData?.filters,
            selectedFilter,
            setSelectedFilter,
          }}
        />

        <div className="u-flex u-flexAlignItemsCenter u-marginVert5gu">
          <div className="Form-label u-flexAuto u-marginBottom0">
            Displaying{' '}
            <span className="u-textBold" data-qa-automation="literature-count">
              {filtersFunds?.length}
            </span>{' '}
            of{' '}
            <span className="u-textBold" data-qa-automation="literature-count">
              {filterDataByClass?.length}
            </span>{' '}
            Documents
          </div>
          <div>
            <a
              className="Link u-padding2gu HeaderLinks-link"
              href={getRelativeBasePath() + '/resources/literature/cart-order'}
            >
              View Cart
            </a>
          </div>
        </div>
        {/* TABLE */}
        {isEmpty(fundsData) ? (
          <Loader showBackground={false} />
        ) : (
          <FundLiteratureTable
            showClassOption={showClassOption}
            funds={filtersFunds}
            isInvestor={IS_INVESTOR}
          />
        )}
      </div>
      <div id="ampf-trace-loaded-page"></div>
    </div>
  )
}

FundLiterature.propTypes = {
  showClassOption: PropTypes.bool,
  inputValue: PropTypes.string,
  setInputValue: PropTypes.func,
  activeClass: PropTypes.string,
  setActiveClass: PropTypes.func,
  fundsData: PropTypes.shape({
    classOptions: PropTypes.array,
    filters: PropTypes.array,
  }),
  selectedFilter: PropTypes.string,
  setSelectedFilter: PropTypes.func,
}
